const removeSlash = (url: string): string => {
  return url && url.endsWith('/') ? url.slice(0, -1) : url;
};
const {
  VITE_APP_DEFAULT_AUTH,
  VITE_BASE_URL,
  VITE_AD_CLIENT_ID,
  VITE_AD_AUTHORITY,
  VITE_AD_REDIRECT_URL,
  VITE_AD_POST_LOGOUT_URL,
  VITE_AD_DISABLE,
  VITE_GOOGLE_CLIENT_ID,
  VITE_GOOGLE_CLIENT_SECRET,
  VITE_GOOGLE_DISABLE,
  VITE_THAID_CLIENT_ID,
  VITE_THAID_CLIENT_SECRET,
  VITE_THAID_AUTH_URI,
  VITE_THAID_REDIRECT_URI,
  VITE_THAID_DISABLE,
  VITE_APPLE_DISABLE,
  VITE_APPLE_CLIENT_ID,
  VITE_APPLE_REDIRECT_URI,
  VITE_AUTH_APP_URL,
  VITE_POLICY_ID,
  VITE_POLICY_TENANT_ID,
  VITE_POLICY_CHANNEL,
  VITE_MOBILE_THAID_REDIRECT_URI
} = import.meta.env;

const appConfigs = {
  auth: VITE_APP_DEFAULT_AUTH,
  baseUrl: removeSlash(VITE_BASE_URL),
  ad_client_id: VITE_AD_CLIENT_ID,
  ad_authority: VITE_AD_AUTHORITY,
  ad_redirect_url: VITE_AD_REDIRECT_URL,
  ad_post_logout_url: removeSlash(VITE_AD_POST_LOGOUT_URL),
  ad_disable: VITE_AD_DISABLE ? VITE_AD_DISABLE.toLowerCase() === "true" : false,
  google_client_id: VITE_GOOGLE_CLIENT_ID,
  google_client_secret: VITE_GOOGLE_CLIENT_SECRET,
  google_disable: VITE_GOOGLE_DISABLE ? VITE_GOOGLE_DISABLE.toLowerCase() === "true" : false,
  thaid_client_id: VITE_THAID_CLIENT_ID,
  thaid_client_secret: VITE_THAID_CLIENT_SECRET,
  thaid_auth_uri: removeSlash(VITE_THAID_AUTH_URI),
  thaid_redirect_uri: removeSlash(VITE_THAID_REDIRECT_URI),
  thaid_disable: VITE_THAID_DISABLE ? VITE_THAID_DISABLE.toLowerCase() === "true" : false,
  apple_disable: VITE_APPLE_DISABLE ? VITE_APPLE_DISABLE.toLowerCase() === "true" : false,
  apple_client_id: VITE_APPLE_CLIENT_ID,
  apple_redirect_uri: removeSlash(VITE_APPLE_REDIRECT_URI),
  auth_app_url: removeSlash(VITE_AUTH_APP_URL),
  policy_id: VITE_POLICY_ID,
  policy_tenant_id: VITE_POLICY_TENANT_ID,
  policy_channel: VITE_POLICY_CHANNEL,
  mobile_thaid_redirect_uri: VITE_MOBILE_THAID_REDIRECT_URI,
};
export default appConfigs;
